import { render, staticRenderFns } from "./BrandLogo.vue?vue&type=template&id=f7b83834&scoped=true"
import script from "./BrandLogo.vue?vue&type=script&lang=js"
export * from "./BrandLogo.vue?vue&type=script&lang=js"
import style0 from "./BrandLogo.vue?vue&type=style&index=0&id=f7b83834&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7b83834",
  null
  
)

export default component.exports